import {gql} from '@apollo/client'

const GET_Konkursy = gql`
query Konkursy($id_uczestnika:Int!) {
    uczestnik_konkurs(id_uczestnika:$id_uczestnika){
        id_konkursu
        nr_ogloszenia
        jednostka
        data_konkurs
        nazwa_stanowiska
        status_konkursu
        data_testu
    }
}
`
const GET_AktywneKonkursy = gql`
query AktywneKonkursy($status:String!) {
    aktywne_konkursy(status:$status){
        id_konkursu
        nr_ogloszenia
        jednostka
        data_konkurs
        nazwa_stanowiska
        status_konkursu
        data_testu
        czas
    }
}
`
const GET_Test = gql`
query Test($id_uczestnika:Int!) {
    test(id_konkursu:$id_konkursu){
        id_testu
    }
}
`
const GET_ListaPytan = gql`
query ListaPytan($id_konkursu:Int!) {
     pytania(id_konkursu:$id_konkursu){
     id_pytania
     } 
}
`
const GET_Pytanie = gql`
query Pytanie($id_pytania:Int!) {
    pytanie(id_pytania:$id_pytania){
        id_odpowiedzi
        tresc_odpowiedzi
        tresc_pyt
        id_pytania
    }
}
`
const GET_Punkty = gql`
query Pytanie($id_uczestnika:Int!,$id_konkursu:Int!) {
    punkty(id_uczestnika:$id_uczestnika,id_konkursu:$id_konkursu){
       poprawne
       bledne
       brak
       suma
    }
}
`

const GET_Udzielone_Odpowiedzi = gql`
query Pytanie($id_uczestnika:Int!,$id_konkursu:Int!) {
    kontynuacja_pytania(id_uczestnika:$id_uczestnika,id_konkursu:$id_konkursu){
       id_pytania
    }
}
`
const GET_Liczba_Pytan = gql`
query Pytanie($id_uczestnika:Int!,$id_konkursu:Int!) {
    liczba_pytan(id_uczestnika:$id_uczestnika,id_konkursu:$id_konkursu){
       liczba_pytan
    }
}
`
export {GET_Konkursy, GET_Pytanie,GET_ListaPytan,GET_Test,GET_Punkty,GET_Udzielone_Odpowiedzi,GET_Liczba_Pytan, GET_AktywneKonkursy}